// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const UptakesList    = lazy(() => import('../../views/uptakes/list'))

const Uptakes = [
  {
    path: '/uptakes/list',
    element: <UptakesList />
  }
]

export default Uptakes
